import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _map from 'lodash/map';
import Content from '../../../atoms/Content';
import StyleButtonWithDropdown from '../styleButton/StyleButtonWithDropdown';
import { getBlockDataValueForSelection } from '../helpers/rickTextEditor.helpers';
import { BLOCK_STYLE_PREFIX, BLOCK_STYLE_TYPES, LINE_HEIGHT_TYPES } from '../styles.contants';
export default function LineHeightControl(props) {
  var _LINE_HEIGHT_TYPES$;
  var control = props.control,
    onToggle = props.onToggle,
    editorState = props.editorState;
  var lineHeight = getBlockDataValueForSelection(editorState)("".concat(BLOCK_STYLE_PREFIX).concat(BLOCK_STYLE_TYPES.LINE_HEIGHT)) || ((_LINE_HEIGHT_TYPES$ = LINE_HEIGHT_TYPES['150']) === null || _LINE_HEIGHT_TYPES$ === void 0 ? void 0 : _LINE_HEIGHT_TYPES$.value);
  var lineHeights = useMemo(function () {
    return _map(LINE_HEIGHT_TYPES, function (lineHeightType) {
      return _objectSpread(_objectSpread({}, lineHeightType), {}, {
        render: function render() {
          return /*#__PURE__*/React.createElement(Content, null, lineHeightType.label);
        }
      });
    });
  }, []);
  var onToggleHandler = function onToggleHandler(lineHeightValue) {
    return onToggle(lineHeightValue);
  };
  return /*#__PURE__*/React.createElement(StyleButtonWithDropdown, {
    key: control.label,
    active: false,
    label: control.label,
    onClick: onToggleHandler,
    icon: control.icon,
    items: lineHeights,
    activeItem: lineHeight
  });
}
LineHeightControl.propTypes = {
  editorState: PropTypes.object.isRequired,
  control: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired
};